import { render } from "./ItemFilePreview.vue?vue&type=template&id=0c0672f6&scoped=true"
import script from "./ItemFilePreview.vue?vue&type=script&lang=ts"
export * from "./ItemFilePreview.vue?vue&type=script&lang=ts"

import "./ItemFilePreview.vue?vue&type=style&index=0&id=0c0672f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c0672f6"

export default script